import React from 'react';
import { connect } from 'react-redux';

import HeaderStocksNavigation from 'stocks/components/HeaderStocksNavigation';

class StockTakeLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <HeaderStocksNavigation salonId={this.props.salonId} history={this.props.history} PageTitle="Stocktake" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
  } = state;
  return {
    salonId,
  };
}

export default connect(
  mapStateToProps,
  null,
)(StockTakeLayout);
